import React, { useState, useEffect, useCallback } from 'react';
import ContentLayout from '../../layout/ContentLayout';
import styles from '../../styles/vip.module.scss';
import { Container } from '../../components/content';
import { Link, useParams } from 'react-router-dom';
import GenericTable from '../../components/tables/GenericTable';
import VipAdditionalInfoTable from './vipAdditionalInfoTable';
import { fetchVipDetails } from '../../api/vips-api';

const Vip = () => {
  const { id } = useParams();
  const [vipDetails, setVipDetails] = useState(null);
  console.log('VIP ID:', id);
  const dataBasicInfo = [
    {
      info: 'Ime i prezime',
      value: vipDetails?.fullName || '-',
    },
    { info: 'Grad', value: vipDetails?.city || '-' },
    { info: 'Ulica i broj', value: vipDetails?.address || '-' },
    { info: 'Broj telefona', value: vipDetails?.phone || '-' },
    {
      info: 'Email',
      value: vipDetails?.email || '-',
    },
  ];
  const columnsBasicInfo = [
    { key: 'info', label: 'Osnovne informacije' },
    { key: 'value', label: '' },
  ];

  const columnsCharacteristics = [
    { key: 'characteristic', label: 'Karakteristike' },
    { key: 'detail', label: '' },
  ];
  const dataCharacteriestics = [
    {
      characteristic: 'Godine',
      detail: vipDetails?.age || '-',
    },
    {
      characteristic: 'Težina (kg)',
      detail: vipDetails?.weight || '-',
    },
    {
      characteristic: 'Visina (cm)',
      detail: vipDetails?.height || '-',
    },
    {
      characteristic: 'Krvna grupa',
      detail: vipDetails?.blood || '-',
    },
  ];

  const additionalData = {
    diseases: vipDetails?.hasHealthIssues || false,
    therapy: vipDetails?.onMedicalTherapy || false,
    medicins: vipDetails?.takesDailyMeds || false,
    surgeries: vipDetails?.hadSeriousSurgery || false,
    food: vipDetails?.diet || '-',
    howManyMeals: vipDetails?.mealsPerDay || '-',
    cigarettes: vipDetails?.cigarettes || false,
    supplements: vipDetails?.supplements || '-',
  };

  const getTableData = useCallback(async () => {
    const { data, success, message } = await fetchVipDetails(id);

    if (!success) {
      console.log(message || 'Error while fetching the vip details.');
      return;
    }

    setVipDetails(data);
  }, [id]);

  useEffect(() => {
    getTableData();
  }, [getTableData]);
  console.log('fetched vip details:', vipDetails);

  return (
    <>
      <Container className={styles.vip}>
        <Link to={'/vips'} className="link_btn">
          <img alt="back image" src="/assets/icons/chevron.svg" />
          <span>Nazad</span>
        </Link>
        <div>
          <ContentLayout pt={true}>
            <div className={styles.vip__inner}>
              <p className="title">
                Detalji VIP člana: {vipDetails?.fullName || '-'}
              </p>
              <div className={styles.vip__grid}>
                <div>
                  <GenericTable
                    data={dataBasicInfo}
                    columns={columnsBasicInfo}
                    grayTheme={true}
                    mobNoScroll={true}
                  />
                </div>
                <div className={styles.vip__grid__characteristics}>
                  <GenericTable
                    data={dataCharacteriestics}
                    columns={columnsCharacteristics}
                    grayTheme={true}
                    mobNoScroll={true}
                  />
                </div>
              </div>
              <div>
                <VipAdditionalInfoTable data={additionalData} />
              </div>
            </div>
          </ContentLayout>
        </div>
      </Container>
    </>
  );
};
export default Vip;
